module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"row api-keys\"> <div class=\"col-md-10\"> <table class=\"test-api-key-table\"> <thead> <tr> <th colspan=\"2\">Test Secret API Key</th> <th class=\"created-on-header text-center\">Created On</th> <th class=\"status-header text-center\">Status</th> </tr> </thead> <tbody> ")
    ;  _.each(locals.testApiKeys, function(testKey) { 
    ; __append(" <tr id=\"apiKey_")
    ; __append(escapeFn( testKey.key ))
    ; __append("\" class=\"")
    ; __append(escapeFn( testKey.active ? 'active' : 'inactive bg-lightest' ))
    ; __append("\"></tr> ")
    ;  }); 
    ; __append(" </tbody> </table> <table class=\"prod-api-key-table\"> <thead> <tr> <th> Production Secret API Key </th> </tr> </thead> <tbody> ")
    ;  _.each(locals.prodApiKeys, function(prodKey) { 
    ; __append(" <tr id=\"apiKey_")
    ; __append(escapeFn( prodKey.key ))
    ; __append("\" class=\"")
    ; __append(escapeFn( prodKey.active ? 'active' : 'inactive bg-lightest' ))
    ; __append("\"></tr> ")
    ;  }); 
    ; __append(" </tbody> </table> <button class=\"btn btn-red create-new\">Create New Key</button> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/api_keys_list.ejs
// module id = 822
// module chunks = 1